import React, { useState, useEffect } from "react";

import { instance } from "../../common";

function LoadRegion({ isName, isRegion, onRegionClick }) {
  const [data, setData] = useState([]);
  let obj = { si_area1: isName };
  console.log("obj : ", obj);

  useEffect(() => {
    const fetchData = async () => {
      instance.post("/sigong/si_area1", obj).then(function (res) {
        setData(res.data);
      });
    };

    fetchData();
  }, [isName]);

  const wordBreak = {
    wordBreak: "keep-all",
    cursor: "pointer",
  };

  return (
    <>
      {data.map((v) =>
        v.si_area2.length === 3 ? (
          isRegion == v.si_area2 ? (
            <div
              key={v.si_area2}
              className="col-4 text-center font-weight-bold pointer dClick mb-3 pl-2 pr-2"
              onClick={onRegionClick}
              data-name={v.si_area2}
            >
              <div
                className="border findActive p-1"
                data-name={v.si_area2}
                style={wordBreak}
              >
                {v.si_area2}
              </div>
            </div>
          ) : (
            <div
              key={v.si_area2}
              className="col-4 text-center mb-3 font-weight-bold  dClick pl-2 pr-2"
              onClick={onRegionClick}
              data-name={v.si_area2}
            >
              <div
                className="border p-1"
                data-name={v.si_area2}
                style={wordBreak}
              >
                {v.si_area2}
              </div>
            </div>
          )
        ) : (
          <></>
        )
      )}
      {data.map((v) =>
        v.si_area2.length === 4 ? (
          isRegion == v.si_area2 ? (
            <div
              key={v.si_area2}
              className="col-4 text-center font-weight-bold dClick mb-3 pl-2 pr-2"
              onClick={onRegionClick}
              data-name={v.si_area2}
            >
              <div
                className="border findActive p-1"
                data-name={v.si_area2}
                style={wordBreak}
              >
                {v.si_area2}
              </div>
            </div>
          ) : (
            <div
              key={v.si_area2}
              className="col-4 text-center mb-3 font-weight-bold dClick pl-2 pr-2"
              onClick={onRegionClick}
              data-name={v.si_area2}
            >
              <div
                className="border p-1"
                data-name={v.si_area2}
                style={wordBreak}
              >
                {v.si_area2}
              </div>
            </div>
          )
        ) : (
          <></>
        )
      )}
      {data.map((v) =>
        v.si_area2.length > 4 ? (
          isRegion == v.si_area2 ? (
            <div
              key={v.si_area2}
              className="col-4 text-center font-weight-bold dClick mb-3 pl-2 pr-2"
              onClick={onRegionClick}
              data-name={v.si_area2}
            >
              <div
                className="border findActive p-1"
                data-name={v.si_area2}
                style={wordBreak}
              >
                {v.si_area2
                  .split("")
                  .map((items, index) => (index !== 3 ? items : " " + items))}
              </div>
            </div>
          ) : (
            <div
              key={v.si_area2}
              className="col-4 text-center mb-3 font-weight-bold dClick pl-2 pr-2"
              onClick={onRegionClick}
              data-name={v.si_area2}
            >
              <div
                className="border p-1"
                data-name={v.si_area2}
                style={wordBreak}
              >
                {v.si_area2
                  .split("")
                  .map((items, index) => (index !== 3 ? items : " " + items))}
              </div>
            </div>
          )
        ) : (
          <></>
        )
      )}
    </>
  );
}

export default LoadRegion;
